import { render, staticRenderFns } from "./sequenceSetting.vue?vue&type=template&id=10d050be&scoped=true&"
import script from "./sequenceSetting.vue?vue&type=script&lang=js&"
export * from "./sequenceSetting.vue?vue&type=script&lang=js&"
import style0 from "./sequenceSetting.vue?vue&type=style&index=0&id=10d050be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d050be",
  null
  
)

export default component.exports